export default function PesquisarEstoque(){
    return(
        <div>
            <h1>Pesquisar Estoque</h1>
            <p>Descrever funcionalidades</p>
        </div>
    )
}